import { render, staticRenderFns } from "./PersonalProfileCdcModule.vue?vue&type=template&id=11992f35&scoped=true&"
import script from "./PersonalProfileCdcModule.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileCdcModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11992f35",
  null
  
)

export default component.exports